<h1 mat-dialog-title class="text-capitalize">{{data.isEdit ? '' : 'Új'}} csomópont @if (node.id) {
  <span class="text-muted small float-end">#{{node.id}}</span>
}</h1>
<div mat-dialog-content>
  <mat-form-field class="w-100">
    <mat-label>Cég</mat-label>
    <input matInput type="text" name="company" [(ngModel)]="node.company" disabled readonly>
  </mat-form-field>

  <app-select-search label="Telephely" [list]="sites" [model]="node.siteid" (modelChanged)="node.siteid = $event;" [isRequired]="true" [isDisabled]="data.isEdit || node.parent"></app-select-search>

  @if (data.isEdit) {
    <mat-form-field class="w-100">
      <mat-label translate>DEVICE</mat-label>
      <input matInput type="text" placeholder="Device" name="role" [(ngModel)]="installedDeviceName" disabled readonly>
      @if (node.isDatalogger()) {
        <button matSuffix mat-raised-button color="primary" (click)="onReplaceBtnClick()">Csere</button>
      }
    </mat-form-field>
  }

  @if (!data.isEdit || showReplace) {
    <mat-form-field class="w-100">
      <mat-label translate>DEVICE</mat-label>
      <mat-select [(ngModel)]="node.deviceid" [required]="true">
        @for (item of devices; track item) {
          <mat-option [value]="item.id" [disabled]="(item.isDatalogger() && !dataLoggerOnly) || (item.isMeter() && dataLoggerOnly)">
            {{item.name}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }

  @if (showReplace) {
    <mat-form-field class="w-100">
      <mat-label>Megjegyzés</mat-label>
      <textarea matInput name="logmsg" id="logmsg" rows="5" [(ngModel)]="node.message"></textarea>
    </mat-form-field>
  }

  <div class="row">

    <div class="col-md-4">
      <mat-form-field class="w-100">
        <mat-label>Target</mat-label>
        <input matInput type="text" placeholder="Target" name="target" [(ngModel)]="node.target">
      </mat-form-field>
    </div>
    <div class="col-md-4">
      <mat-form-field class="w-100">
        <mat-label>CompanyRole</mat-label>
        <input matInput type="text" placeholder="CompanyRole" name="role" [(ngModel)]="node.companyrole">
      </mat-form-field>
    </div>
    <div class="col-md-4">
      <mat-form-field class="w-100">
        <mat-label>Offset</mat-label>
        <input matInput type="number" min="0" placeholder="Offset" name="offset" [(ngModel)]="node.offset">
        @if (offset) {
          <mat-hint>Default: {{offset}}</mat-hint>
        }
      </mat-form-field>
    </div>

    <div class="col-md-6">
      <mat-form-field class="w-100">
        <mat-label>Kezdete</mat-label>
        <input  matInput #sdInput [matDatepicker]="sdPicker" (focus)="sdPicker.open()" name="start_date" [(ngModel)]="node.start" (dateChange)="onDateChange('start')">
        <mat-datepicker-toggle matSuffix [for]="sdPicker"></mat-datepicker-toggle>
        <mat-datepicker #sdPicker (closed)="sdInput.blur()"></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-md-6">
      <mat-form-field class="w-100">
        <mat-label>Vége</mat-label>
        <input  matInput #edInput [matDatepicker]="edPicker" (focus)="edPicker.open()" name="end_date" [(ngModel)]="node.end" (dateChange)="onDateChange('end')">
        <mat-datepicker-toggle matSuffix [for]="edPicker"></mat-datepicker-toggle>
        <mat-datepicker #edPicker (closed)="edInput.blur()"></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
</div>
<div mat-dialog-actions align="end">
  @if (node && node.id) {
    <button mat-button (click)="onConfirmDelete()" color="warn"><span translate>DELETE</span></button>
  }
  <button mat-button (click)="onNoClick()"><span translate>CLOSE</span></button>
  <button mat-button color="primary" (click)="onSaveClick()"><span translate>SAVE</span></button>
</div>
